// StatStrip — 6-card horizontal KPI strip for landing surfaces (CHG-1238).
//
// Wraps the CHG-1225 StatCards primitive with a 6-column override and a
// strip-specific item shape. Items map 1:1 to StatCardDef under the hood;
// no styling overrides leak past the props that StatCards already supports.

import { StatCards, type StatCardDef } from "./StatCards";
import type { ToneToken } from "../../lib/stage-tone-heuristic";

export type StatStripFormat = "currency" | "number";

export interface StatStripItem {
  id: string;
  label: string;
  value: number | null | undefined;
  format: StatStripFormat;
  tone?: ToneToken;
  currency?: string;
}

export interface StatStripProps {
  items: StatStripItem[];
  loading?: boolean;
}

export function StatStrip({ items, loading }: StatStripProps) {
  // StatCards' grid auto-collapses on narrow viewports because the
  // gridTemplateColumns uses `repeat(cols, minmax(0, 1fr))` — the explicit
  // 6-column override here matches the 6 KPI cards Overview ships. Callers
  // that want fewer cards (e.g., 4-card variants in future flagship pages)
  // can pass fewer items and the grid follows item count.
  const cards: StatCardDef[] = items.map((item) => ({
    id: item.id,
    label: item.label,
    value: item.value,
    format: item.format,
    tone: item.tone,
    currency: item.currency,
  }));
  return <StatCards cards={cards} loading={loading} columns={items.length} />;
}
